import NumberService from "./Number.service";
class ListService {
    static displayWithCommasAndAnd(list, max) {
        return ListService.displayWithCommasAndSomething(list, "and", max);
    }
    static displayWithCommasAndOr(list, max) {
        return ListService.displayWithCommasAndSomething(list, "or", max);
    }
    static displayWithCommasAndSomething(list, something, max) {
        if (!list || list.length === 0) {
            return "";
        }
        if (max != null && list.length > max) {
            list = list
                .slice(0, max)
                .concat([
                `${NumberService.format(list.length - max)} other${list.length - max === 1 ? "" : "s"}`,
            ]);
        }
        if (list.length === 1) {
            return list[0];
        }
        if (list.length === 2) {
            return `${list[0]} ${something} ${list[1]}`;
        }
        return (list.slice(0, list.length - 1).join(", ") +
            `, ${something} ` +
            list[list.length - 1]);
    }
    static unique(list, getKey = (v) => v) {
        if (!list || !list.length) {
            return [];
        }
        const seen = new Set();
        return list.filter((item) => {
            const key = getKey(item);
            if (seen.has(key)) {
                return false;
            }
            seen.add(key);
            return true;
        });
    }
    /**
     * Groups an array into a list of "chunks" of a given size.  For example,
     * `ListService.chunk([1,2,3,4,5,6], 3) ~> [[1, 2, 3], [4,5,6]]`
     *
     * @param {T[]} list - the list to chunk
     * @param {number} chunkSize - the size of each chunk
     * @returns {T[][]} array of chunks
     */
    static chunk(list, chunkSize) {
        if (!(list === null || list === void 0 ? void 0 : list.length)) {
            return [];
        }
        const tempArray = [];
        for (let i = 0; i < list.length; i += chunkSize) {
            tempArray.push(list.slice(i, i + chunkSize));
        }
        return tempArray;
    }
    static groupBy(list, by) {
        return list.reduce((map, item) => {
            var _a;
            const label = by(item);
            if (!label) {
                return map;
            }
            map.set(label, ((_a = map.get(label)) !== null && _a !== void 0 ? _a : []).concat([item]));
            return map;
        }, new Map());
    }
    static groupByString(list, by) {
        return list.reduce((sum, item) => {
            const label = by(item);
            if (!label) {
                return sum;
            }
            return Object.assign(Object.assign({}, sum), { [label]: sum[label] ? sum[label].concat([item]) : [item] });
        }, {});
    }
    static isArray(arr) {
        return Array.isArray(arr);
    }
    static isEmptyArray(arr) {
        return ListService.isArray(arr) && arr.length === 0;
    }
    static isNullOrEmpty(arr) {
        return arr == null || ListService.isEmptyArray(arr);
    }
    static makeIntoList(arr) {
        return ListService.isArray(arr) ? arr : [arr];
    }
    static shallowEqual(a, b, excludedIndices = []) {
        if (a === b) {
            return true;
        }
        return a.every((av, ai) => excludedIndices.includes(ai) || av === b[ai]);
    }
    /**
     * Given a list, inserts an item into the list at the index position provided
     */
    static insertIntoList(list, index, value) {
        if (Array.isArray(index)) {
            return index
                .toSorted((a, b) => a - b)
                .reduce((sum, i, ii) => ListService.insertIntoList(sum, i - ii, value), list);
        }
        return list.slice(0, index).concat([value]).concat(list.slice(index));
    }
    /**
     * Given a list of entries, returns a random entry from the list
     */
    static getRandomFromList(list) {
        if (list.length === 0) {
            throw new Error("Invalid list provided");
        }
        const randomIndex = Math.floor(Math.random() * list.length);
        return list[randomIndex];
    }
}
ListService.returnNullIfEmpty = (arr) => {
    if (arr == null || arr.length === 0) {
        return null;
    }
    return arr;
};
/**
 * Gives the original index in an array that has had some of its elements removed.
 *
 * @param {number} index - the index in the array that has had elements removed
 * @param {number[]} removedIndexes - the indexes of the elements that have been removed
 * @returns {number} the index in the original array.
 */
ListService.getOriginalIndex = (index, removedIndexes) => {
    let originalIndex = index;
    for (const removedIndex of removedIndexes) {
        if (removedIndex <= originalIndex) {
            originalIndex++;
        }
    }
    return originalIndex;
};
export default ListService;
